import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';
import { NavLink, useNavigate }          from 'react-router-dom';
import { IMAGES_BASE_PATH } from '../../config/constants';
import CookieUtil           from "../../utils/cookieUtil";

interface NavBarProps {
  isSocialHeader?: boolean;
  socialData:any;
  midSectionSettings:any
}
const NavBar: React.FC<NavBarProps> = ({isSocialHeader,socialData,midSectionSettings}) => {
    const eventData                         = useSelector((state: any) => state.eventData); 
    const navigate=useNavigate()
          
    const excludedKeys = ['countdown_timer', 'welcome_note','speaker_statistics'];

    return (
      // <!--Header area section-->
<header className="header-area">
    <div className="container-fluid">
        {/* <!-- Nav --> */}
        <nav className="navbar navbar-expand-lg">
            {/* <!-- Logo --> */}
            <div id="">
            {eventData?.website_logo?.key && (
                <NavLink onClick={() => window.location.reload()} to='/' className="">
                    <img
                    src={IMAGES_BASE_PATH + eventData.website_logo.key}
                    alt="logo"
                    />
                </NavLink>
            )}
           
            </div>
            {/* <!-- Logo ends! --> */}
            {/* <!--menu toggler --> */}
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu"
                    aria-expanded="false" aria-label="Toggle navigation">
               <span className="navbar-toggler-icon">
               <span className="ti-menu"></span>
               </span>
            </button>
            {/* <!--menu toggler ends! --> */}
            {/* <!--menu --> */}
            <div className="collapse navbar-collapse" id="menu">
                <ul id="menu_scroll" className="navbar-nav menu">
                    <li><a href="#home" className="scroll active">Home</a></li>
                    <li><a href="#register" className="scroll">Register</a></li>
                    <li>
                        <a href="/3D" onClick={()=>{navigate('/3D')}} className="scroll">Login</a>
                        
                    </li>
    
                    {Array.isArray(midSectionSettings) &&
                    midSectionSettings
                        .filter(item => item.is_show && !excludedKeys.includes(item.key))
                        .sort((a, b) => a.sort_order - b.sort_order)
                        .map(item => (
                        <li key={item.key}>
                            <a href={`#${item.key}`} className="scroll">
                            {item.label}
                            </a>
                        </li>
                        ))}

                </ul>
            </div>
            {/* <!--menu ends!--> */}
           
 {isSocialHeader && (
             <div className="social-icons-wrapper ml-auto" style={{float:"right",margin:"10px 10px 6px 3px"}}> 
     
            <ul className="social-icons ml-auto">
                {socialData &&
                socialData
                    .filter((item: any) => item.status)
                    .map((item: any) => {
                    const iconMap: { [key: string]: string } = {
                        facebook: "icon-facebook",
                        twitter: "icon-twitter",
                        linkedin: "icon-linkedin-1",
                        instagram: "icon-instagram",
                        youtube: "icon-youtube-play",
                        insta: "icon-instagram",              // alias for Instagram
                        tiktok: "icon-tiktok",
                        pinterest: "icon-pinterest-circled",
                        whatsapp: "icon-whatsapp",
                        snapchat: "icon-snapchat-ghost",
                        reddit: "icon-reddit",
                        github: "icon-github",
                        dribbble: "icon-dribbble",
                        behance: "icon-behance",
                        medium: "icon-medium",
                        telegram: "icon-telegram",
                        discord: "icon-discord",
                    };

                    const iconClass = iconMap[item.title.toLowerCase()] || "icon-link";

                    return (
                        <li key={item._id}>
                        <a
                            href={
                            item.url.startsWith("http") ? item.url : `https://${item.url}`
                            }
                            target={item.is_open_new_window ? "_blank" : "_self"}
                            rel="noopener noreferrer"
                            title={item.title}

                            style={{
   '--before-bg': eventData.primary_color
  }}
                        >
                            <i className={iconClass}></i>
                        </a>
                        </li>
                    );
                    })}
            </ul>
            </div>
            )}
        </nav>
        {/* <!-- Nav ends!--> */}
       

    </div>
</header>




        
        
    )

}

export default NavBar;
